module.exports = __webpack_public_path__ + "media/images/admin/icons/gift-ded019c1379db2778a36dc7d496332bf.svg";